<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">调用接口</h1>
		<h2 class="doc_main_h2">识别图像</h2>
		<h3 class="doc_main_h3">1.直接调用</h3>
		<h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (NSData *)SKEyeSDK_Image:(UIImage *)image serviceName:(SK_SERVICE_NAME*)serviceName;</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）serviceName：识别服务名称</p>
        <p class="doc_main_p">（2）image:图片</p>
        <h4 class="doc_main_h4">返回值</h4>
        <sk-eye-json></sk-eye-json>
        <h3 class="doc_main_h3">2.接口回调</h3>
        <h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (void)SKEyeSDK_Image:(UIImage *)image serviceName:(SK_SERVICE_NAME*)
	serviceName callBack:(void(^)(id responseObject))callBack;
//可携带参数imageId 标记图片唯一性
+ (void)SKEyeSDK_ImageId:(NSString *)imageId image:(UIImage *)
    image service_name:(SK_SERVICE_NAME*)serviceName callBack:(void(^)(id responseObject))callBack;
</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）serviceName：识别服务名称</p>
        <p class="doc_main_p">（2）image：图片</p>
        <p class="doc_main_p">（3）imageId：图片ID</p>
        <p class="doc_main_p">（4）callback：回调接口</p>
        <h4 class="doc_main_h4">返回值</h4>
        <sk-eye-json></sk-eye-json>
        <h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// 直接调用
NSData *dd = [eyeTool SKEyeSDK_Image:image service_name:SERVICE_NAME_OBJECT];
// 接口回调
[eyeTool SKEyeSDK_Image:image service_name:SERVICE_NAME_OBJECT callBack:^(id responseObject) {
            // 处理回调数据
 }];
//接口回调，可携带参数imageId
[eyeTool SKEyeSDK_ImageId:@"1" image:image service_name:_serviceName callBack:^(id responseObject) {
        if (responseObject == nil) {
            return ;
        }
        NSDictionary *dic = [NSJSONSerialization JSONObjectWithData:
       		responseObject options:NSJSONReadingAllowFragments error:nil];
          	NSString *imageId = dic[@"image_id"];
        NSLog(@"%@",dic);
        //处理回调数据 
}];</code></pre>


        <h2 class="doc_main_h2">识别url（网络url、本地路径）图像</h2>
        <h3 class="doc_main_h3">1.直接调用</h3>
		<h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (NSData *)SKEyeSDK_ImagePath:(NSString *)imagePath service_name:(SK_SERVICE_NAME*)serveName;</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）serviceName：识别服务名称</p>
        <p class="doc_main_p">（2）imagePath：图像的url（网络url或者本地路径）</p>
        <h4 class="doc_main_h4">返回值</h4>
        <sk-eye-json></sk-eye-json>

        <h3 class="doc_main_h3">2.接口回调</h3>
        <h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (void)SKEyeSDK_ImagePath:(NSString *)imagePath service_name:
	(SK_SERVICE_NAME*)serveName callBack:(void(^)(id responseObject))callBack;
//可携带参数imageId 标记图片唯一性
+ (void)SKEyeSDK_ImageId:(NSString *)imageId imagePath:(NSString *)imagePath service_name:
	(SK_SERVICE_NAME*)serviceName callBack:(void(^)(id responseObject))callBack;
</code></pre>
		<h4 class="doc_main_h4">参数</h4>
		<p class="doc_main_p">（1）serviceName：识别服务名称</p>
        <p class="doc_main_p">（2）imagePath：图像的url（网络url或者本地路径）</p>
        <p class="doc_main_p">（3）imageId：图片ID</p>
        <p class="doc_main_p">（4）callback：回调接口</p>
        <h4 class="doc_main_h4">返回值</h4>
        <sk-eye-json></sk-eye-json>
        <h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// 直接调用
NSData *jsonData = [eyeTool SKEyeSDK_ImagePath:@"图像路径" service_name:SERVICE_NAME_OBJECT];
// 接口回调
[eyeTool SKEyeSDK_ImagePath:@"图片路径" service_name:SERVICE_NAME_OBJECT callBack:^(id responseObject) {
         // 处理回调数据
}];
//接口回调，可携带参数imageId
[eyeTool SKEyeSDK_ImagePath:@"图片URL" service_name:_serviceName callBack:^(id responseObject) {
        NSDictionary *dic = [NSJSONSerialization JSONObjectWithData:
    responseObject options:NSJSONReadingAllowFragments error:nil];
    NSLog(@" %@",dic);
         // 处理回调数据
}];</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	import SKEyeJson from '../../../components/SKEyeJson'
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'sk-eye-json':SKEyeJson,
		},
		data(){
			return{
				isPathData:['物体识别','SKEye-iOS','调用接口'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skeyeios/callImageInterface.vue